import React, { useEffect } from 'react'
import { getSiteGid } from 'src/_helpers'
export const Analytics = (props) => {
  useEffect(() => {
      console.log(getSiteGid(), props)
    }, []);
  return (
    <></>
  );
};
